import { render, staticRenderFns } from "./AppForgotPassword.vue?vue&type=template&id=a1f1ef4a&scoped=true&"
import script from "./AppForgotPassword.vue?vue&type=script&lang=js&"
export * from "./AppForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./AppForgotPassword.vue?vue&type=style&index=0&id=a1f1ef4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f1ef4a",
  null
  
)

export default component.exports